import { AutogenLayoutZoneRegion } from "./autogen/AutogenLayoutZoneRegion";
import { DuplicateId, DuplicateIdProps } from "./DuplicateId";

export class ZoneRegion extends AutogenLayoutZoneRegion {

    override onLoad(): void | Promise<void> {
        this.validateZoneRegionRecordExist();
    }

    private validateZoneRegionRecordExist() {
        const zoneRegionUrl = "lme/dispatch/ZoneRegion?mode=update&key=";
        const validateProps: DuplicateIdProps = { tableName: "zone_region", screenName: "ZoneRegion", navigateToUrl: zoneRegionUrl };
        DuplicateId.configureIdTextbox(this.textboxId, validateProps);
    }

}
